import { render, staticRenderFns } from "./OpenBillingRecursiveInvoiceTable.vue?vue&type=template&id=5b2cd19e&scoped=true&"
import script from "./OpenBillingRecursiveInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./OpenBillingRecursiveInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingRecursiveInvoiceTable.vue?vue&type=style&index=0&id=5b2cd19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2cd19e",
  null
  
)

export default component.exports